import React from 'react';
import PropTypes from 'prop-types';
import styles from './RoundButton.module.css';

const RoundButton = (
  {
    hidden,
    onClick,
    data,
    icon,
    buttonSize,
    transparent,
    tooltip,
    tooltipTxt
  }) => {
  if (hidden === true)
    return null
  transparent ? transparent = 'transparent' : null

  function showTooltip(element) {
    let parent = element.parentElement.parentElement.children['tooltip']
    parent.style.opacity = 1
    parent.style.visibility = 'visible'
    setTimeout(() => {
      parent.style.opacity = 0
      parent.style.visibility = 'hidden'
    }, 1300)
  }

  return (
    <div className={`${styles.RoundButton} ${styles[transparent]}`}>
      <button
        buttonsize={buttonSize}
        onClick={(e) => {
          onClick()
          tooltip ? showTooltip(e.target) : undefined
        }}
      >
        <img src={icon} />
      </button>
      <div name="tooltip" className={styles.copiedMessage}>{tooltipTxt}</div>
    </div>
  )
}

RoundButton.propTypes = {};

RoundButton.defaultProps = {};

export default RoundButton;
